import { getServiceVersion } from '@/apis/Version'
import { Version, VersionService } from '@repo/ui'
import { useConfig } from '@/features/config/providers/ConfigProvider'
import { version as frontendVersion } from '../../../../package.json'

export default function VersionContainer() {
  const { softwareVersion } = useConfig()

  const services: VersionService[] = [
    {
      testId: 'backend',
      queryKey: 'backendServiceVersion',
      labelKey: 'version.components.backend',
      queryFn: getServiceVersion
    }
  ]

  return (
    <Version
      softwareVersion={softwareVersion}
      frontendVersion={frontendVersion}
      services={services}
    />
  )
}
